import { useThunkReducer } from '@shared/hooks/useThunkReducer';
import React from 'react';
import { FlowStep } from '../../components/FlowStep';
import { StepDate } from './components/StepDate';
import { StepTime } from './components/StepTime';
import {
  init,
  selectCurrentStep,
  selectLabel,
  selectMessage,
  stepDateTimeReducer,
} from './reducers/stepDateTimeReducer';

export const StepDateTime = (props) => {
  const [state, dispatch, useSelector] = useThunkReducer(stepDateTimeReducer, {
    devToolsName: props.devToolsName,
    initializerArg: props,
    initializer: init,
  });

  const currentStep = useSelector(selectCurrentStep);
  const label = useSelector((state) => selectLabel(state, props.config));
  const message = useSelector((state) => selectMessage(state, props.config, props.data));

  return (
    <FlowStep label={label} message={message}>
      {React.createElement(getStepBy(currentStep), {
        step: currentStep,
        state: state,
        dispatch: dispatch,
        useSelector: useSelector,
        required: props.config.required,
        onComplete: props.completeStep,
        config: props.config,
      })}
    </FlowStep>
  );
};

const stepBy = {
  date: StepDate,
  time: StepTime,
};

const getStepBy = (currentStep) => stepBy[currentStep] ?? stepBy.date;
